/* eslint-disable no-param-reassign */
import { styled } from '@mui/material';
import { GridSkeleton } from '../../../../components/Grid';

const PREFIX = 'FinancialsTables';

export const classes = {
  additionalHistoricalYearsContent: `${PREFIX}-additionalHistoricalYearsContent`,
  additionalHistoricalYearsTxt: `${PREFIX}-additionalHistoricalYearsTxt`,
  additionalHistoricalYearsLink: `${PREFIX}-additionalHistoricalYearsLink`,
};

export const StyledGridSkeleton = styled(GridSkeleton)({
  [`& .${classes.additionalHistoricalYearsContent}`]: {
    marginTop: '2em',
  },
  [`& .${classes.additionalHistoricalYearsTxt}`]: {
    marginRight: '0.5em',
  },
  [`& .${classes.additionalHistoricalYearsLink}`]: {
    marginLeft: '0.5em',
    marginBottom: '0.2em',
  },
});